import { c as _c } from "react/compiler-runtime";
import { FaroTableFooterContainer } from "@components/common/faro-table/faro-table-footer-container";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { Box } from "@mui-wrapper";
import { ChevronLeftIcon, ChevronRightIcon, Tooltip } from "@flat-ui";
import { UiUtils } from "@stellar/utils";
/**
 * The footer of the table that shows the pagination information.
 */
export function FaroTableFooter(t0) {
  const $ = _c(31);
  const {
    paginationModel,
    totalItems,
    changePage,
    paginationProps,
    shouldDisableNextPage: t1,
    disabledNextPageTooltip: t2
  } = t0;
  const shouldDisableNextPage = t1 === undefined ? false : t1;
  const disabledNextPageTooltip = t2 === undefined ? "Please load more items first" : t2;
  const isTotalKnown = totalItems !== -1;
  if (isTotalKnown && totalItems <= paginationModel.pageSize) {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        marginLeft: "4px"
      };
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    let t4;
    if ($[1] !== totalItems) {
      t4 = <FaroTableFooterContainer>Total rows{" "}<Box component="strong" sx={t3}>{totalItems}</Box></FaroTableFooterContainer>;
      $[1] = totalItems;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  const isOnLastPage = paginationProps.lastPage === paginationModel.page;
  const t3 = `${paginationProps.from} ${UiUtils.DASH} ${paginationProps.to} `;
  let t4;
  if ($[3] !== t3) {
    t4 = <Box component="strong">{t3}</Box>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      marginX: "4px"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isTotalKnown || $[7] !== paginationProps.to || $[8] !== totalItems) {
    t6 = <Box component="span" sx={t5}>{isTotalKnown ? <>of <var>{totalItems}</var></> : <>of more than <var>{paginationProps.to}</var></>}</Box>;
    $[6] = isTotalKnown;
    $[7] = paginationProps.to;
    $[8] = totalItems;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = paginationModel.page === 0;
  let t8;
  if ($[10] !== changePage || $[11] !== paginationModel.page) {
    t8 = () => changePage(paginationModel.page - 1);
    $[10] = changePage;
    $[11] = paginationModel.page;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <SphereIconButton component={ChevronLeftIcon} isDisabled={t7} onClick={t8} buttonSize="28px" iconSize="20px" />;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Box component="span" sx={{
      marginRight: "4px"
    }} />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = shouldDisableNextPage && !isOnLastPage ? disabledNextPageTooltip : "";
  const t12 = shouldDisableNextPage || isOnLastPage;
  let t13;
  if ($[17] !== changePage || $[18] !== paginationModel.page) {
    t13 = () => changePage(paginationModel.page + 1);
    $[17] = changePage;
    $[18] = paginationModel.page;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13) {
    t14 = <SphereIconButton component={ChevronRightIcon} isDisabled={t12} onClick={t13} buttonSize="28px" iconSize="20px" />;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t11 || $[24] !== t14) {
    t15 = <Tooltip component="div" title={t11}>{t14}</Tooltip>;
    $[23] = t11;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t15 || $[27] !== t4 || $[28] !== t6 || $[29] !== t9) {
    t16 = <FaroTableFooterContainer>{t4}{t6}{t9}{t10}{t15}</FaroTableFooterContainer>;
    $[26] = t15;
    $[27] = t4;
    $[28] = t6;
    $[29] = t9;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}